import React, { useEffect, useRef, useState } from 'react';
import { CharitiesService } from 'services/charities/charities';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CardGiftcard from '@material-ui/icons/CardGiftcard';
import styles from 'assets/jss/material-dashboard-pro-react/views/topup/donationDialogStyle';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ICharityInfoProps {
	url: string;
	size?: 'sm' | 'md';
}

const CharityLogo = ({ url, size = 'md' }: ICharityInfoProps) => {
	const [logo, setLogo] = useState<string>('');
	const isMounted = useRef(true);
	const classes = useStyles();
	const imageClasses = classNames(classes.imageWrapper, {
		[classes[`${size}Icon`]]: true,
	});

	useEffect(() => {
		if (!!url) {
			CharitiesService.getImageByPartialPath(url).subscribe((logoUrl) => {
				if (isMounted.current) {
					setLogo(logoUrl);
				}
			});
		}
	}, [url]);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	return (
		<>
			<div className={imageClasses}>
				<ConditionalRender
					show={!!logo}
					onTrue={() => <img src={logo} alt="charity logo" />}
					onFalse={() => <CardGiftcard />}
				/>
			</div>
		</>
	);
};

export default CharityLogo;
